// Bundle of all 4 confirmation modals used by MicRecorder (extracted to keep MicRecorder < 100 lines).
import { VoiceConfirmModal } from "@/components/add/VoiceConfirmModal";
import { InstallmentConfirmModal } from "@/components/add/InstallmentConfirmModal";
import { EarlyPaymentAIModal } from "@/components/installments/EarlyPaymentAIModal";
import { CommitmentConfirmModal } from "@/components/add/CommitmentConfirmModal";

export function MicRecorderModals({ preview, installment, earlyAi, commitment, close }) {
  return (
    <>
      <VoiceConfirmModal open={!!preview} transcript={preview?.transcript} extracted={preview?.extracted}
        onClose={() => close("preview")} onSaved={() => close("preview")} />
      {installment && (
        <InstallmentConfirmModal key={installment.transcript || Math.random()} open transcript={installment.transcript}
          preview={installment.preview} onClose={() => close("installment")} onSaved={() => close("installment")} />
      )}
      {earlyAi && (
        <EarlyPaymentAIModal open transcript={earlyAi.transcript} previewData={earlyAi.previewData}
          onClose={() => close("earlyAi")} onSaved={() => close("earlyAi")} />
      )}
      {commitment && (
        <CommitmentConfirmModal open transcript={commitment.transcript} preview={commitment.preview}
          onClose={() => close("commitment")} onSaved={() => close("commitment")} />
      )}
    </>
  );
}
